<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/jala-farm";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit JALA Farms",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_farms.singular')) }},
    resourceRoute: {default: 'jala_farms'},
    modelVariable: {default: 'jala_farm'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_farms.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_farms.plural')),
          href: "/jala_farms",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/jala_farms/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/jala_farms/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/jala/farms/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/jala/farms/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/jala/farms/${this.$route.params.key}`)
    }
  }
}
</script>
